<template>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12>
                <v-img src="static/prudentDiversityBg.jpg"></v-img>
            </v-flex>
            <v-flex v-for="i in 3" :key="`6${i}`" xs4>
                <v-card dark color="secondary">
                    <v-card-text class="px-0">6</v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "DiversityHome"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/prudent/diversity/DiversityHome.vue